<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZN45Wj/media/FC-9789948043430.jpg?1685203786283" alt="This image is the cover for the book Zaina"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Zaina
      </h1>
      <p class="bookDescription body article font2">
        <p>In her eyes, there  is a mysterious secret; a city of secrets and a unique power...  Whoever dived into her eyes, he would enter other depths, settled in them and never wanted to leave. Zaina ia a Challenge, a confrontation, a silence and a revelation...  Zaina is all what  a girl needs. Zaina is love, patience, strength and beauty... Zaina belongs to Zaina’s time only.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rania Namer Eitah
      </h2>
      
      <p class="authorDescription body article">Rania Namer Eitah is a writer of prose stories, novels, and poetry. She was born in Syria, in 1981. She holds a Bachelor of Arts degree in English literature, from Damascus University. She also holds a postgraduate educational certificate from Damascus University, in English language, and is also a human development trainer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4215428a